import { Text } from '@chakra-ui/react'

import { useAppStore } from '../../store/appStore/appStore'
import { PageHeaderContainerWidget } from '../PageHeaderContainerWidget/PageHeaderContainerWidget'
import { PageHeaderContainerWidgetProps } from '../PageHeaderContainerWidget/PageHeaderContainerWidget'
import { createWidget } from '../widget-utils'

export interface DashboardPageHeaderContainerWidgetProps
  extends Omit<PageHeaderContainerWidgetProps, 'children'> {}

export const DashboardPageHeaderContainerWidget = ({
  ...pageHeaderContainerProps
}: DashboardPageHeaderContainerWidgetProps = {}) => {
  const organizationDisplayName = useAppStore(
    store => store.auth.user?.organization?.display_name ?? '',
  )

  return (
    <PageHeaderContainerWidget
      marginTop="0"
      marginX="0"
      paddingTop="0"
      paddingX="0"
      paddingBottom="0"
      backgroundColor="transparent"
      {...pageHeaderContainerProps}
    >
      <Text
        textTransform="uppercase"
        fontSize="16px"
        fontWeight="700"
        zIndex={1}
        lineHeight="19.2px"
        letterSpacing="2.8px"
        marginTop="4px"
        color="currentColor"
      >
        {organizationDisplayName}
      </Text>
    </PageHeaderContainerWidget>
  )
}

export const DashboardPageHeaderContainerWidgetDefinition = createWidget(
  DashboardPageHeaderContainerWidget,
  {
    type: 'DashboardPageHeaderContainer',
  },
)
